import { createContext } from 'react';

const SupportScreenContext = createContext( null );

export default SupportScreenContext;